import { useViewEvent } from 'features/events/context/ViewEvent';
import EventInfo from '../EventInfo';
import Header from '../../../../../components/checkout/Header';
import CenteredContainer from 'components/CenteredContainer';
import Button from 'components/Button';
import SummaryItem from './components/SummaryItem';
import TransactionDetails from '../../../../../components/checkout/TransactionDetails';
import PaymentOptions from '../../../../../components/checkout/PaymentOptions';
import { CheckoutSteps } from '../../types';
import ConfirmOrderButton from './components/ConfirmOrderButton';
import Loader from 'legacy/common/components/layout/Loader';
import { useCheckout } from '../../context';
import { useMemo } from 'react';
import TopBackgroundWrapper from 'components/checkout/TopBackgroundWrapper';
import CheckoutTimer from '../CheckoutTimer';
import useCheckoutSummary from '../../context/hooks/useCheckoutSummary';
import { useTranslation } from 'react-i18next';

const SummaryStep = () => {
  const { t } = useTranslation(['checkout']);
  const { event } = useViewEvent();
  const checkoutSummaryData = useCheckoutSummary();
  const {
    tickets,
    ticketTiers,
    isLoading,
    user,
    goToStep,
    checkoutSession,
    paymentMethod,
    addNewCardAndSave,
    selectBuyNowPayLaterAndSave,
    selectCardAndSave
  } = useCheckout();
  const selectedTiersData = useMemo(
    () =>
      ticketTiers.data.filter(
        (tier) => !!tickets.selectedTicketTiers[tier._id]
      ),
    [tickets.selectedTicketTiers, ticketTiers.data]
  );

  const goToTicketTiers = () => {
    goToStep(CheckoutSteps.TicketTiers);
  };

  const goBack = () => {
    if (ticketTiers.data?.some((tier) => tier.type === 'addon')) {
      goToStep(CheckoutSteps.TicketTiersAddon);
    } else {
      goToStep(CheckoutSteps.TicketTiers);
    }
  };

  return (
    <Loader isOverlay isLoading={isLoading}>
      <Header
        onBack={goBack}
        title={t('checkout:checkout')}
        subtitle={event.title}
        isUserLoggedIn={!!user}
        TimerComponent={CheckoutTimer}
      />
      <TopBackgroundWrapper
        imageUrl={event.photo.url}
        hasTierNav={false}
        isUserLoggedIn={!!user}
        className="pb-8 md:pb-14"
      >
        <EventInfo />
      </TopBackgroundWrapper>
      <CenteredContainer hasPadding={false} wideContent>
        <div className="px-4 gap-5 md:gap-8 flex flex-col md:flex-row pb-10">
          <div className="w-full md:w-2/3">
            <div className="md:max-w-[650px] ">
              <h3 className="text-base md:text-lg font-semibold md:font-bold">
                {t('checkout:summary', {
                  count: tickets.totalAmountOfTicketsSelected
                })}
              </h3>
              <div className="gap-5 flex flex-1 flex-col">
                <div className="border-b-2 border-neutral-200 pb-5">
                  <ul>
                    {selectedTiersData.map((selectedTier) => (
                      <SummaryItem key={selectedTier._id} tier={selectedTier} />
                    ))}
                  </ul>
                  <Button
                    variant="secondary"
                    onClick={goToTicketTiers}
                    size="large"
                    className="w-full"
                  >
                    {t('checkout:addMoreItems')}
                  </Button>
                </div>
                <TransactionDetails
                  checkoutSummaryData={checkoutSummaryData}
                  total={checkoutSession.checkoutSession?.total || 0}
                  currency={checkoutSession.checkoutSession?.currency}
                />
              </div>
            </div>
          </div>
          <div className="flex flex-col gap-4 md:w-1/3 min-w-[350px]">
            <PaymentOptions
              total={checkoutSession.checkoutSession?.total || 0}
              isLoadingCheckout={checkoutSession.isLoadingCheckout}
              currency={checkoutSession.checkoutSession?.currency}
              paymentMethod={paymentMethod}
              addNewCard={addNewCardAndSave}
              selectBuyNowPayLater={selectBuyNowPayLaterAndSave}
              Actions={<ConfirmOrderButton />}
              selectCard={selectCardAndSave}
            />
          </div>
        </div>
      </CenteredContainer>
      <div className="fixed bottom-0 left-0 right-0 bg-white p-4 border-neutral-200 border-t-1 md:hidden">
        <ConfirmOrderButton />
      </div>
    </Loader>
  );
};

export default SummaryStep;
